module.exports = __webpack_public_path__ + "static/img/tubka_b.c8ca85b6.png";